import { makeStyles } from "@mui/styles";

const topBarStyle = makeStyles((theme) => ({
    topBarContainer: {
        position: "absolute",
        top: "1.5rem",
        left: "1.5rem",
        display: "flex",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.8)", // Light color
        borderRadius: "23px", // Rounded rectangle
        padding: "1px 20px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        zIndex: 100,
        [theme.breakpoints.down("sm")]: {
            top: "2.1rem",
            padding: '0.3rem',
            gap: '0.6rem',
        },
    },
    iconButton: {
        backgroundColor: "transparent",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
        },
        [theme.breakpoints.down("sm")]: {
            transform: "scale(1.3)", // ✅ Increase button size for mobile
        },
    },
    icon: {
        fontSize: "35px",
        color: "#333",
    },
    logoContainer: {
        display: "flex",
        alignItems: "center",
        marginLeft: "10px",
        paddingRight: "2rem",
    },
    logo: {
        height: "30px",
        marginLeft: "10px",
    },
    logoText: {
        fontSize: "0.9rem !important",
        color: theme.palette.text.primary,
        paddingLeft: "1rem",
        paddingRight: "2rem",
    },
    treeViewPopover: {
        padding: "12px",
        minWidth: "250px",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
        borderRadius: "10px",
        maxHeight: "400px",
        overflowY: "auto",
        [theme.breakpoints.down("sm")]: {
           width: '100px',
        },
    },
    // ✅ Add this to show active button effect
    activeButton: {
        backgroundColor: "rgba(80, 139, 195, 0.4)!important",  // Change button color when active
        color: "#fff !important",
    },
}));

export default topBarStyle;
